/* global SunergoPlatform, A11yDialog */

class SPDialog extends HTMLElement {
	constructor() {
		super();

		this.elements = {};
		this.elements.title = this.querySelector('[data-title]');
		this.elements.body = this.querySelector('[data-body]');

		if (!SunergoPlatform.dialogs) {
			SunergoPlatform.dialogs = {
				items: [],
				get: function(name) {
					const dialog = this.items[name];
					if (dialog) return dialog;
					else {
						console.error('[SunergoPlatform] Dialog not found.', name);
						return false;
					}
				}
			};
		}
	}


	connectedCallback() {
		if (typeof A11yDialog !== 'function') return console.error('Missing library: A11yDialog.');

		this.appWrapper = document.getElementsByClassName('app-wrapper')[0];

		this.dialog = new A11yDialog(this);
		this.dialog
			.on('show', this.onShow.bind(this))
			.on('hide', this.onHide.bind(this));

		this.initConfirmCode();
		this.initUploadProgress();

		SunergoPlatform.dialogs.items[this.dataset.dialogBox] = this.dialog;
		if (this.dataset.showOnLoad == 'true') this.dialog.show();
	}

	get id() {
		return this.getAttribute('id');
	}

	set id(value) {
		this.setAttribute('id', value);

		// Set aria-labelledby.
		this.setAttribute('aria-labelledby', `${value}-title`);
		this.elements.title.id = `${value}-title`;
	}

	onShow() {
		// Disable body scroll.
		this.appWrapper.style.overflow = 'hidden';

		this.dataset.closing = 'false';
	}

	onHide() {
		// Enable body scroll.
		this.appWrapper.style.overflow = '';
		if (window.matchMedia('(prefers-reduced-motion)').matches) return;

		this.addEventListener('animationend', function() {
			if (this.dataset.closing === 'true') this.dataset.closing = 'false';
		}, { once: true });

		this.dataset.closing = 'true';
	}

	/**
	 * When an action is dangerous, check confirm code before continuing with action.
	 */
	initConfirmCode() {
		const confirmCode = this.dataset.dialogConfirmCode;
		const confirmField = this.querySelector('[data-dialog-confirm-field]');
		if (!confirmCode || !confirmField) return;

		const confirmInput = confirmField.querySelector('[data-dialog-confirm-input]');
		const confirmError = this.querySelector('[data-dialog-confirm-error]');

		const element = this;
		this.querySelectorAll('[data-dialog-confirm-check]').forEach(form => {
			form.addEventListener('submit', function(e) {
				// if the confirmCode matches the value from user, submit the form
				if (confirmCode == confirmInput.value.trim()) return true;

				// if they don't match, stop submission and let the user know
				e.preventDefault();
				confirmError.innerHTML = confirmError.dataset.dialogConfirmError;
				confirmField.dataset.status = 'error';

				const submitButton = element.querySelector('[data-disable-on-active]');
				if (submitButton) SunergoPlatform.actionButtons.setActive(submitButton, false);
			});
		});
	}

	/**
	 * Initialize progress bar.
	 */
	initUploadProgress() {
		const progressBar = this.querySelector('[data-progress-bar]');
		if (!progressBar) return;

		const progressIndicator = progressBar.querySelector('[data-progress-indicator]');
		const progressLabel = progressBar.querySelector('[data-progress-label]');

		this.dialog.setProgress = function(value) {
			const status = value > 100 ? 'indeterminate' : value < 0 ? 'waiting' : value;
			progressBar.dataset.progressBar = status;

			if (isNaN(status) && status != 'waiting') {
				progressLabel.textContent = '';
				return;
			}

			if (value > 100) value = 100;
			else if (value < 0) value = 0;

			progressIndicator.style.width = value + '%';
			progressLabel.textContent = value + '%';
		};
	}

	setup(content) {
		if (content.title && this.elements.title) this.elements.title.innerHTML = content.title;
		if (content.body && this.elements.body) this.elements.body.innerHTML = content.body;
	}

	show() {
		this.dialog.show();
	}

	hide() {
		this.dialog.hide();
	}
}
customElements.define('sp-dialog', SPDialog);